import produce from 'immer';
import create from 'zustand';

const useStore = create(set => ({
  followed: false,
  hasFeesPricing: false,
  hasPerformanceUpdates: false,
  hasInvest: false,
  showTooltip: false,
  tooltipTitle: '',
  tooltipContent: [],
  set: fn => set(produce(fn)),
}));

export default useStore;
